module.exports = __webpack_public_path__ + "static/media/mc_front_closed.acb0f339.svg";